export default __webpack_public_path__ + "static/media/livelinklist-mobile.c58e6799.png";